const lang = {
    en: {
        search:"Search",
        gptSearchPlaceholder: "What do you want to watch today?"
    },
    tr: {
        search:"Ara",
        gptSearchPlaceholder: "Bugun ne izlemek istersin?"
    },
    spanish: {
        search:"buscar",
        gptSearchPlaceholder: "Qué quieres ver hoy?"
    }
};

export default lang;